import { HeadingClass, HeadingType } from 'enums'
import React from 'react'

export const getHeadingClass = (headingClass: string) => {
  let classList = ''
  switch (headingClass) {
    case HeadingClass.H1:
      classList = 'font-medium h1 text-4xl sm:text-6xl'
      break
    case HeadingClass.H2:
      classList = 'font-medium h2 text-3xl sm:text-4xl'
      break
    case HeadingClass.H3:
      classList = 'font-medium text-2xl h3 sm:text-3xl'
      break
    case HeadingClass.H4:
      classList = 'font-medium text-lg sm:text-2xl h4'
      break
    case HeadingClass.H5:
      classList = 'font-medium text-base sm:text-lg h5'
      break
    case HeadingClass.H6:
      classList = 'font-medium text-sm sm:text-base h6'
      break
  }

  return classList
}

interface Props {
  children: any
  classList?: string
  headingType: HeadingType
  headingClass: HeadingClass
  color: string
}

const CustomHeading = ({ children, classList, headingType, headingClass, color }: Props) => {
  const headingClasses = getHeadingClass(headingClass)

  if (headingType === HeadingType.H1) {
    return (
      <h1 className={`${classList} ${headingClasses}`} style={{ color }}>
        {children}
      </h1>
    )
  }

  if (headingType === HeadingType.H2) {
    return (
      <h2 className={`${classList} ${headingClasses}`} style={{ color }}>
        {children}
      </h2>
    )
  }

  if (headingType === HeadingType.H3) {
    return (
      <h3 className={`${classList} ${headingClasses}`} style={{ color }}>
        {children}
      </h3>
    )
  }

  if (headingType === HeadingType.H4) {
    return (
      <h4 className={`${classList} ${headingClasses}`} style={{ color }}>
        {children}
      </h4>
    )
  }

  if (headingType === HeadingType.H5) {
    return (
      <h5 className={`${classList} ${headingClasses}`} style={{ color }}>
        {children}
      </h5>
    )
  }

  if (headingType === HeadingType.H6) {
    return (
      <h6 className={`${classList} ${headingClasses}`} style={{ color }}>
        {children}
      </h6>
    )
  }

  // if (headingType === HeadingType.P) {
  // }
  // default case is a paragraph tag
  return (
    <p className={`${classList} ${headingClasses} line-height-fix`} style={{ color }}>
      {children}
    </p>
  )
}

export default CustomHeading

export const headingTypePropObj = {
  name: 'headingType',
  type: 'string',
  enum: ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P'],
  defaultValue: 'P'
}

export const headingClassPropObj = {
  name: 'headingClass',
  type: 'string',
  enum: ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
  defaultValue: 'H1'
}
